import { BatchSummaryDto } from "~/types/api";

/**
 * Determines if a batch is ready to be picked based on whether a cart has been assigned to the batch
 */
export const canBatchBePicked = (batch: BatchSummaryDto): boolean => {
  // we need a cartId assigned to the batch before the user can pick
  return batch.batchType === "Bulk" || !!batch.cartId;
};
